import React, { useContext, useEffect } from "react"
import { Redirect } from "react-router"
import AppContext from "../../../../shared/AppContext"
import { DEFAULT_LOGO } from "../../../../shared/constants"
import "./style.scss"

const SectorPage = (props) => {
  const { trackPage, openInquireModal, serviceType } = useContext(AppContext)
  const { topic } = props
  const { id, type, logo, name, description } = topic

  useEffect(() => {
    trackPage("Topic Page: Sector", {
      topicId: id,
      topicName: name,
      topicType: type.toUpperCase(),
    })
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [id])

  if (!props.viewer || !props.viewer.isUserAuthenticated) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: props.location.pathname } }}
      />
    )
  }

  return (
    <header className="topic-header">
      <section>
        <img src={logo ? logo : DEFAULT_LOGO} className="topic-header-image" />
      </section>
      <section>
        <h1 className="topic-header-title"> {name}</h1>
        {description && (
          <p
            dangerouslySetInnerHTML={{ __html: description }}
            className="topic-header-description"
          />
        )}
      </section>
    </header>
  )
}

export default SectorPage
